/* eslint-disable prefer-arrow/prefer-arrow-functions */
import React from "react"
import B2BSignupForm from './B2BSignupForm'



function RightSidePage(){
return (<div className="m-3">
  <B2BSignupForm/>
</div>)
}

export default RightSidePage